$(function() 
{
    setupPressSpaceToStartButtonFade();
});

let setupPressSpaceToStartButtonFade = () => 
{
    $('.press-space-to-start').on('transitionend', () => {
        $(this).hide();
    });
}

let restartGameClicked = () => 
{
    $('.press-space-to-start').show().removeClass('removed');
}